export const productsFeedsRowsPerPage = [10, 20, 50];

export const TAB_INGESTION_TO_CYMBIO = 'Ingestion to Cymbio';
export const TAB_CHANNELS = 'Channels';
